module.exports = __webpack_public_path__ + "img/horizontal_7_4_5012.8a45673d.png";